import { StorageClient, StorageService, type StoredFile } from '@/modules/databaseService/types';
import { BackendClient } from '@/infrastructure/clients/BackendClient';


// Creates storage services using the backend API
export function createServices() {
  // Storage goes through the backend proxy
  const storageClient = new BackendStorageClientAdapter();

  return {
    storage: createStorageService(storageClient),
  };
}


export class BackendStorageClientAdapter implements StorageClient {
  from(bucket: string) {
    const storage = BackendClient.storage.from(bucket);

    return {
      upload: (path: string, blob: Blob, options: any) => storage.upload(path, blob, options),
      getPublicUrl: (path: string) => storage.getPublicUrl(path),
      remove: (paths: string[]) => storage.remove(paths),
      list: (prefix: string) => storage.list(prefix),
    };
  }
}


export class SupabaseStorageAdapter implements StorageService {
  private readonly bucket = 'image_files';

  constructor(private readonly client: StorageClient) {}

  async uploadFile(path: string, blob: Blob, options: any): Promise<{ data?: StoredFile | null; error: any }> {
    const { data, error } = await this.client
      .from(this.bucket)
      .upload(path, blob, options);
    return { data, error };
  }

  getPublicUrl(path: string): { data: { publicUrl: string } } {
    return this.client
      .from(this.bucket)
      .getPublicUrl(path);
  }

  async deleteFile(path: string): Promise<{ error: any }> {
    const { error } = await this.client
      .from(this.bucket)
      .remove([path]);
    return { error };
  }

  async listFiles(prefix: string): Promise<{ data: string[]; error: any }> {
    try {
      const { data, error } = await this.client
        .from(this.bucket)
        .list(prefix);
      
      if (error) throw error;
      
      return { 
        data: data.map((file: any) => file.name),
        error: null
      };
    } catch (error) {
      return { data: [], error };
    }
  }
}

export function createStorageService(client: StorageClient): StorageService {
  return new SupabaseStorageAdapter(client);
}
